import React, { Component } from 'react';
import Util from '../../script/util';
import './index.scss';

class GeneralUid extends Component {
  render() {
    const { uid, style, className, color } = this.props;
    if (!uid) return null;
    return (
      <p className={Util.classNames('general-num', className)} style={style}>
        <span className="icon-uid">{/* UID ICON */}</span>
        <span className="uid-num" style={{ color }}>
          {uid}
        </span>
      </p>
    );
  }
}

GeneralUid.defaultProps = {
  style: {},
  color: '#999',
};

export default GeneralUid;
